export type ScrollListener = (y: number) => void

export interface ObservedScrollingOptions {
	modifyingElement: HTMLElement | HTMLElement[]
	observedElement?: HTMLElement
}

let disableAnimation = false
const setReducedMotion = () => disableAnimation = matchMedia('(prefers-reduced-motion: reduce)').matches

addEventListener('DOMContentLoaded', setReducedMotion)
addEventListener('focus', setReducedMotion)

export default class ObservedScrolling {
	private readonly listeners = new Set<ScrollListener>()
	private observedElement: HTMLElement
	private modifyingElements: HTMLElement[]
	public disabled = false
	private requestedFrame: number

	public constructor(options: ObservedScrollingOptions) {
		this.observedElement = options.observedElement || document.body
		this.modifyingElements = Array.isArray(options.modifyingElement)
			? options.modifyingElement
			: [options.modifyingElement]

		if (this.observedElement == document.body) {
			addEventListener('scroll', this.onScroll, { passive: true })
		}
		else {
			this.observedElement.addEventListener('scroll', this.onScroll, { passive: true })
		}

		addEventListener('load', this.onScroll)
		this.tick()
	}

	public addListener(fn: ScrollListener) {
		this.listeners.add(fn)
	}

	public removeListener(fn: ScrollListener) {
		this.listeners.delete(fn)
	}

	public onScroll = () => {
		if (this.disabled || !this.observedElement || this.modifyingElements.length == 0) {
			return
		}

		const y = this.observedElement == document.body ? scrollY : this.observedElement.scrollTop
		if (y != this.modifyingElements[0].scrollTop) {
			this.modifyingElements.forEach(el => el.scrollTop = y)
			this.listeners.forEach(fn => fn(y))
		}
	}

	private tick = (timestamp: number = 0) => {
		this.requestedFrame = requestAnimationFrame(this.tick)
		this.onScroll()
	}
}